<template>
    <div class="screenSecurity2" id="nav" :style="'font-size:18px'">
        <ScaleBox :width="1920" :height="1080" bgc="transparent" :delay="100">
            <div class="pageTop">
                <div :style="'display:flex;align-items:center;'">
                    <img :style="'width:40px;height:40px;'" src="../../assets/imgs/leida.png" />
                    <div style="margin-left:10px;font-size: 25px;">客流分析可视化</div>
                </div>

                <div style="text-align: left;display:flex;justify-content: space-around;align-items: center;">
                    <div style="display:flex;align-items: center;">
                        <div><img style="width:40px;height:40px;" src="../../assets/imgs/shopNum.png" /></div>
                        <div style="font-size:14px;margin-left: 10px;">
                            <div>商户数</div>
                            <div><span style="font-size:25px;color:#6AC1FF;">{{ leftShopList.length }}</span></div>
                        </div>
                    </div>
                    <div style="display:flex;align-items: center;margin-left:100px;">
                        <div><img style="width:40px;height:40px;" src="../../assets/imgs/peopleNum.png" /></div>
                        <div style="font-size:14px;margin-left: 10px;">
                            <div>总人流次</div>
                            <div><span style="font-size:25px;color:#6AC1FF;">{{ allPeople }}</span></div>
                        </div>
                    </div>
                </div>
                <div style="display:flex;align-items:center;">
                    <img :style="'width:30px;height:30px;'" src="../../assets/imgs/time.png" />
                    <div style="margin-left:10px;"><span style="margin-right:30px;color:#29D1FF">{{ nowTime
                    }}</span>{{ getWeek }}</div>
                </div>
            </div>
            <div class="page">

                <div class="pageImg" ref="imgRefDiv" id="heatmap">
                    <img ref="imgRef" @load="loadImage" style="height:100%" mode="heightFix"
                        :src="require('../../assets/imgs/build' + floorIndexImg + '.png')" />
                    <div v-if="item.leftPercent" v-for="(item, index) in placeList" :key="index" :style="'z-index:999999;position:absolute;left:' + Number(((item.leftPercent) / 100 * cavWidth) - 20).toFixed(0) + 'px;'
                        + 'top:' + Number((item.rightPercent) / 100 * cavHeight - 20).toFixed(0) + 'px;'">
                        <div style="color: #ffffff;font-size: 20px;">
                            {{ item.placeName }}
                        </div>
                    </div>
                    <!-- <div  :style="`'width:'${rect.width};'height:'${rect.height};margin:0 auto;`"  ref="imgRefDiv" id="heatmap"></div> -->
                </div>
                <transition name='fade'>
                    <div v-show="leftDivShow" class="leftDiv" @click="closeLeft">
                        <div style="display:flex;align-items: center;height:50px;margin-top:10px;">
                            <!-- <img v-show="!isHaveAll()" style="width:20px;height:20px;cursor: pointer;margin-left:10px;"
                                    @click.stop="beforeFloorList" src="../../assets/imgs/openright.png" /> -->
                            <div class="changeFloor">
                                <div v-for="(item, index) in floorShowList"
                                    :class="floorIndex == item.floorCode ? 'floorShow' : 'floor'"
                                    @click.stop="changeFloor(item.floorCode)">{{ item.floorName }}</div>
                            </div>
                            <!-- <img v-show="isHaveAll()" style="width:20px;height:20px;cursor: pointer;margin-left: 15px;"
                                    @click.stop="nextFloorList" src="../../assets/imgs/openleft.png" /> -->
                        </div>
                        <!-- <div v-for="item in 5" class="shoplist" @click.stop="changeShop(item)">
                                <div>盒马鲜生</div>
                                <div><span style="font-size:22px;color:#6AC1FF;">506</span><span>人</span></div>
                            </div> -->
                        <!-- <div class="left-block">
                            <div class="list-block" :class="{ marquee: true }">
                                <div class="list"
                                    :style="leftShopList.length > 7 ? `animation: row ${leftShopList.length}s linear infinite;` : ''">
                                    <div v-for="(item, index) in leftShopList" class="shoplist"
                                        @click.stop="changeShop(item)" :style="index == 0 ? 'margin-top: 50px;' : ''">
                                        <div>{{ item.placeName }}</div>
                                        <div><span style="font-size:22px;color:#6AC1FF;">{{ item.count
                                        }}</span><span>人</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->


                        <div style="margin-top:30px;margin-left:20px;text-align: left;">楼层客流排名</div>
                        <dv-scroll-ranking-board :config="rightTopData3"
                            style="width:330px;margin:0 auto;height:240px;margin-top:10px;" />

                         <div style="margin-top:50px;margin-left:20px;text-align: left;">店铺客流走势</div>
                        <div class="rightEcharts1" ref="rightEcharts1"></div>    

                        <!-- <div style="margin-left:20px;text-align: left;margin-top:20px;">营收排名</div>
                        <dv-scroll-ranking-board :config="leftData"
                            style="width:330px;margin:0 auto;height:210px;text-align: left;" /> -->


                        <!-- <div style="margin-top:10px;margin-left:20px;text-align: left;">停车实况</div> -->
                        <!-- <div
                            style="text-align: left;display:flex;justify-content: space-around;align-items: center;margin-top:20px;">
                            <div style="display:flex;align-items: center;">
                                <div><img style="width:50px;height:50px;" src="../../assets/imgs/Pcar.png" /></div>
                                <div style="font-size:14px;margin-left: 10px;">
                                    <div>今日进入车辆数</div>
                                    <div><span style="font-size:20px;color:#6AC1FF;">12655</span><span>辆</span>
                                    </div>
                                </div>
                            </div>
                            <div style="display:flex;align-items: center;">
                                <div><img style="width:50px;height:50px;" src="../../assets/imgs/Pcar.png" /></div>
                                <div style="font-size:14px;margin-left: 10px;">
                                    <div>剩余车位</div>
                                    <div><span style="font-size:20px;color:#8FE824;">1655</span><span>个</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="leftEcharts" ref="leftEcharts"></div> -->
                    </div>
                </transition>

                <transition name='fade'>
                    <div v-show="!leftDivShow" class="leftShowButton">
                        <img @click.prevent="openLeft()" src="../../assets/imgs/openleft.png"
                            :style="'cursor: pointer;width:40px;z-index:99999'" mode="widthFix" />
                    </div>
                </transition>

                <transition name='moveR'>
                    <div v-show="!rightDivShow" class="rightShowButton">
                        <img @click="openRight()" src="../../assets/imgs/openright.png"
                            :style="'cursor: pointer;width:40px;z-index:99999'" mode="widthFix" />

                    </div>
                </transition>

                <transition name="moveR">
                    <div class="rightDiv" v-show="rightDivShow" @click="closeRight">
                        <div style="margin-top:80px;margin-left:20px;text-align: left;">今日客流</div>
                        <div
                            style="height:100px;display: flex;justify-content: space-around;margin-top:10px;font-size: 15px;">
                            <dv-border-box-12 style="width:48%">
                                <div style="margin-left:20px;margin-top:15px;">
                                    1楼
                                </div>
                                <div style="margin-left:30px;margin-top:5px;">
                                    <span style="font-size: 23px; color: #7DE6FF;">
                                        {{ this.countOne }}</span>
                                    <span>人次</span>
                                </div>
                            </dv-border-box-12>
                            <dv-border-box-12 style="width:48%">
                                <div style="margin-left:20px;margin-top:15px;">
                                    <!-- {{ this.rightTopData[1].areaName }} -->
                                    总客流
                                </div>
                                <div style="margin-left:30px;margin-top:5px;">
                                    <span style="font-size: 23px; color: #7DE6FF;">
                                        {{ allPeople }}</span>
                                    <span>人次</span>
                                </div>
                            </dv-border-box-12>
                        </div>

                        <!-- <div
                            style="height:100px;display: flex;justify-content: space-around;margin-top:10px;font-size: 15px;">
                            <dv-border-box-12 style="width:48%">
                                <div style="margin-left:20px;margin-top:15px;">
                                    {{ this.rightTopData[2].areaName }}
                                </div>
                                <div style="margin-left:30px;margin-top:10px;">
                                    <span style="font-size: 23px; color: #7DE6FF;">
                                        {{ this.rightTopData[2].count }}</span>
                                    <span>人次</span>
                                </div>
                            </dv-border-box-12>
                            <dv-border-box-12 style="width:48%">
                                <div style="margin-left:20px;margin-top:15px;">
                                    {{ this.rightTopData[3].areaName }}
                                </div>
                                <div style="margin-left:30px;margin-top:10px;">
                                    <span style="font-size: 23px; color: #7DE6FF;">
                                        {{ this.rightTopData[3].count }}</span>
                                    <span>人次</span>
                                </div>
                            </dv-border-box-12>
                        </div> -->
                        <div style="margin-top:60px;margin-left:20px;text-align: left;">时段客流概况</div>
                        <div class="rightEcharts3" ref="rightEcharts3"></div>
                        <!-- <div style="margin-top:10px;margin-left:20px;text-align: left;">楼层客流排名</div>
                        <dv-scroll-ranking-board :config="rightTopData3"
                            style="width:330px;margin:0 auto;height:210px;margin-top:10px;" /> -->
                        <!-- <div style="margin-top:50px;margin-left:20px;text-align: left;">店铺客流走势</div>
                        <div class="rightEcharts1" ref="rightEcharts1"></div> -->

                    </div>
                </transition>
                <!-- <div class="bottomDiv">
                        <dv-border-box-12 style="width:350px" v-proportion="0.6">
    
                        </dv-border-box-12>
                        <dv-border-box-12 style="width:350px" v-proportion="0.6">
    
                        </dv-border-box-12>
                        <dv-border-box-12 style="width:350px" v-proportion="0.6">
    
                        </dv-border-box-12>
                        <dv-border-box-12 style="width:350px" v-proportion="0.6">
    
                        </dv-border-box-12>
                    </div> -->

            </div>
        </ScaleBox>
    </div>
</template>

<script>
import echarts from "echarts";
import ScaleBox from "vue2-scale-box";
import Heatmap from "heatmap.js";
var dayjs = require("dayjs");
export default {
  components: {
    ScaleBox,
  },
  data() {
    return {
      countOne: 0,
      placeCode: "",
      leftData: {},
      dangerCamera: [],
      leftShopList: [],
      floorShowList: [],
      floorList1: [],
      floorList2: [],
      rightTopData: [
        {
          areaName: "",
          count: 0,
        },
        {
          areaName: "",
          count: 0,
        },
        {
          areaName: "",
          count: 0,
        },
        {
          areaName: "",
          count: 0,
        },
      ],
      timer: null,
      configArr: [],
      rightTopData3: {},
      useHeight: 0,
      itemHeight: 0,
      imgScale: 0,
      leftDivShow: true,
      rightDivShow: true,
      floorIndex: "all",
      floorIndexImg: "1020",
      timer3: undefined,
      nowTime: new Date(),
      getWeek: "",
      placeList: [],
      query: {
        buildingCode: "",
        //楼宇编码
        buildingName: "",
        //楼宇名称
        floorCode: "",
        //楼层编码
        floorName: "",
        //楼层名称
        placeCode: "",
        //场所编码
        placeName: "",
        //场所名称
        placeType: "",
        //场所类型
      },
      allPeople: 0,
      hot1: [],
      pointsHot: [], // 热力图数据存放数组
      cavWidth: null, //获取宽度
      cavHeight: null, //获取高度
      rect: {},
    };
  },
  watch: {},
  created() {
    let loading = this.$loading({
      lock: true,
      text: "加载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });

    setTimeout(() => {
      loading.close();
    }, 3000);
    //无需刷新
    this.getFloorList();
    // this.getLeftData2();
    this.nowTimes();
    //需要刷新
    this.getAll();
  },
  mounted() {
    let that=this;
        that.setLeftEcharts()
        that.setRightEcharts3()
  },
  methods: {
    // 初始化热力图
    initHotPic() {
      this.deleteHotMap();
      let self = this;
      var heatmapInstance = Heatmap.create({
        container: document.getElementById("heatmap"),
        gradient: {
          //渐变颜色
          "0": "#4A4A4A", //value为0的颜色
          "0.4": "#82ff6d", //value为500的颜色
          "0.6": "#f3ff6d", //value为1000的颜色
          "1": "#ff6d6d", //value为2000的颜色
        },
        radius: 15,
        maxOpacity: 1,
        minOpacity: 0.2,
        blur: 0.75,
        // radius:30, //半径
        // opacity:0.5, //透明
        // maxOpacity, //热图中最大值具有的最大不透明度
        // minOpacity, //热图中最小值的最小不透明度
        // onExtremaChange, //传递回调以接收极值更改更新
        // blur, //将应用于所有数据点的模糊因子。模糊因子越高，渐变将越平滑
        // xField, //数据点中x坐标的属性名称
        // yField, //数据点中y坐标的属性名称
        // valueField //数据点中y坐标的属性名称
      });

      var max = 0;
      // var width = 600
      // var height = 400
      var data = {
        max: 100, //数据对比(max和min进行数据对比，从而展示热力颜色)
        min: 0,
        data: self.pointsHot,
      };
      heatmapInstance.setData(data);
    },
    getRectValue() {
      let rect2 = this.$refs.imgRefDiv;
      let imgRef = this.$refs.imgRef; //img的dom
      console.log(imgRef);
      this.cavWidth = imgRef.width;
      this.cavHeight = imgRef.height;
      this.pointsHot = [];
      this.hot1.forEach((element) => {
        // console.log()
        var val = element.count;
        // max = Math.max(max, val)
        let point = {
          x: Number((element.leftPercent / 100) * this.cavWidth).toFixed(0),
          y: Number((element.rightPercent / 100) * this.cavHeight).toFixed(0),
          value: val,
        };
        this.pointsHot.push(point);
        let point1 = {
          x: Number(
            (element.leftPercent / 100) * this.cavWidth -
              Math.floor(Math.random() * 10)
          ).toFixed(0),
          y: Number(
            (element.rightPercent / 100) * this.cavHeight -
              Math.floor(Math.random() * 10)
          ).toFixed(0),
          value: val - Math.floor(Math.random() * 10),
        };
        this.pointsHot.push(point1);
        let point2 = {
          x: Number(
            (element.leftPercent / 100) * this.cavWidth -
              Math.floor(Math.random() * 10)
          ).toFixed(0),
          y: Number(
            (element.rightPercent / 100) * this.cavHeight +
              Math.floor(Math.random() * 10)
          ).toFixed(0),
          value: val - Math.floor(Math.random() * 10),
        };
        this.pointsHot.push(point2);
      });
      console.log(this.pointsHot);
      this.initHotPic();
    },

    // 删除之前的热力图
    deleteHotMap() {
      var heatmapBox = document.getElementById("heatmap");
      if (heatmapBox.children.length > 1) {
        var oldCanvas = heatmapBox.children[1];
        heatmapBox.removeChild(oldCanvas);
      }
    },
    //营收排名
    getLeftData2() {
      this.$http.get("/api/safe/passengerFlow/queryEarning", {}).then((res) => {
        if (res.data.code == "200") {
          let arr = [];
          res.data.data.forEach((element) => {
            arr.push({
              name: element.shopName,
              value: element.num,
            });
          });
          this.leftData = {
            data: arr,
            unit: "元",
          };
        }
      });
    },
    //分时段客流统计
    getTimeData() {
      let floorIndex = this.floorIndex;
      if (floorIndex == "all") {
        floorIndex = "";
      }
      this.$http
        .post("/api/safe/passengerFlow/timeSlotStatistics", {
          buildingCode: "",
          floorCode: floorIndex,
        })
        .then((res) => {
          if (res.data.code == "200") {
            let xArr = [];
            let yArr = [];
            let sliceArr = [];
            if (res.data.data.length > 6) {
              sliceArr = res.data.data.slice(-6);
            } else {
              sliceArr = res.data.data;
            }
            sliceArr.forEach((element) => {
              xArr.push(element.hour + ":00");
              yArr.push(element.count);
            });
            this.setRightEcharts3(xArr, yArr);
          }
        });
    },

    //楼层相机热力图
    getHotData() {
      let floorIndex = this.floorIndex;
      if (floorIndex == "all") {
        floorIndex = this.floorIndexImg;
      }
      this.$http
        .post("/api/safe/passengerFlow/cameraHeatMapStatistics", {
          buildingCode: "",
          floorCode: floorIndex,
        })
        .then((res) => {
          if (res.data.code == "200") {
            // 初始化获取数据（模拟的展示数据）
            this.hot1 = res.data.data;
            this.$nextTick(() => {
              this.getRectValue();
              this.getPlaceList();
            });
          }
        });
    },
    //商铺当日客流分析
    getShopData() {
      let floorIndex = this.floorIndex;
      if (floorIndex == "all") {
        floorIndex = "";
      }
      this.allPeople = 0;
      this.$http
        .post("/api/safe/passengerFlow/shopStatistics", {
          buildingCode: "",
          floorCode: floorIndex,
        })
        .then((res) => {
          if (res.data.code == "200") {
            this.leftShopList = res.data.data;
            this.leftShopList.forEach((element) => {
              this.allPeople = this.allPeople + element.count;
            });
            this.changeShop(this.leftShopList[0]);
          }
        });
    },
    //商铺客流走势
    getShopDataQu() {
      let floorIndex = this.floorIndex;
      if (floorIndex == "all") {
        floorIndex = "";
      }
      //获取今天日期
      let dateEnd = dayjs().format("YYYY-MM-DD HH:mm:ss");
      //获取过去/未来N天的日期  前几天
      let dateStart = dayjs()
        .subtract(5, "day")
        .format("YYYY-MM-DD HH:mm:ss");
      let data = {
        buildingCode: "",
        dateStart: dateStart,
        dateEnd: dateEnd,
        floorCode: this.floorCode,
        placeCode: this.placeCode,
      };
      this.$http
        .post("/api/safe/passengerFlow/shopStatisticsTrend", data)
        .then((res) => {
          if (res.data.code == "200") {
            let xArr = [];
            let yArr = [];
            res.data.data.forEach((element) => {
              xArr.push(element.date.substring(5, element.date.length));
              yArr.push(element.count);
            });
            this.setRightEcharts1(xArr, yArr);
          }
        });
    },
    getPlaceList() {
      this.placeList = [];
      this.$http.post("/api/safe/place/getList", this.query).then((res) => {
        if (res.data.code == "200") {
          this.placeList = res.data.data;
          // this.loadImage();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //区域当日客流
    getAll() {
      this.$http
        .post("/api/safe/passengerFlow/areaStatistics", {})
        .then((res) => {
          if (res.data.code == "200") {
            this.rightTopData = [];
            res.data.data.forEach((element) => {
              this.rightTopData.push(element);
            });
            for (let i = 4; i > this.rightTopData.length; i) {
              let data = {
                areaName: "暂无",
                count: 0,
              };
              this.rightTopData.push(data);
            }
          }
        });
    },

    //楼层排名统计
    getFloorData() {
      this.$http
        .post("/api/safe/passengerFlow/floorRankStatistics", {})
        .then((res) => {
          if (res.data.code == "200") {
            let arr = [];
            res.data.data.forEach((element) => {
              let data = {
                name: element.floorName,
                value: element.count,
              };
              arr.push(data);
              if (element.floorName == "1L") {
                this.countOne = element.count;
              }
            });
            this.rightTopData3 = {
              data: arr,
              unit: "人次",
            };
          }
        });
    },

    //获取楼层信息
    getFloorList() {
      this.floorShowList = [];
      this.$http.post("/api/safe/area/floor/getList", {}).then((res) => {
        if (res.data.code == "200") {
          let data = {
            floorName: "全部",
            floorCode: "all",
          };
          this.floorShowList.push(data);
          res.data.data[0].floorInfos.forEach((element) => {
            if (!(Number(element.floorCode) < 1020)) {
              this.floorShowList.push(element);
            }
          });
          this.floorIndex = this.floorShowList[0].floorCode;
          this.changeFloor();
          // this.getAll();
          // this.getHotData();
          // this.getFloorData();
          // this.getShopData();
          // this.getTimeData();
        }
      });
    },
    changeFloor(floorIndex) {
      this.floorIndex = floorIndex || this.floorIndex;
      if (this.floorIndex != "all") {
        this.floorIndexImg = this.floorIndex;
      }
      this.getHotData();

      this.getFloorData();
      this.getShopData();
      this.getTimeData();

      let item = this.getFloorInfo(this.floorIndexImg);
      this.query.floorCode = this.floorIndexImg;
      this.query.floorName = item.floorName;
      this.query.buildingCode = item.buildingCode;
      this.query.buildingName = item.buildingName;
    },
    changeShop(item) {
      this.placeCode = item.placeCode;
      this.getShopDataQu();
    },
    isHaveAll() {
      let status = false;
      this.floorShowList.forEach((element) => {
        if (element.value == "all") {
          status = true;
        }
      });
      return status;
    },
    beforeFloorList() {
      this.floorShowList = this.floorList1;
    },
    nextFloorList() {
      this.floorShowList = this.floorList2;
    },
    openLeft() {
      this.leftDivShow = true;
    },
    closeLeft() {
      this.leftDivShow = false;
    },
    openRight() {
      this.rightDivShow = true;
    },
    closeRight() {
      this.rightDivShow = false;
    },
    setRightEcharts1(xArr1, yArr1) {
      let xArr = xArr1;
      let yArr = yArr1;
      var option = {
        backgroundColor: "",
        tooltip: {},
        grid: {
          top: "6%",
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xArr,
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff", //x轴颜色
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // name: "(辆)",
            nameTextStyle: {
              color: "#ffffff",
              align: "right",
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ffffff", //y轴颜色
              },
            },
            splitLine: {
              // show: false,
            },
          },
        ],
        series: [
          {
            // name: "",
            type: "bar",
            barWidth: "30%",
            data: yArr,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" },
              ]),
            },
          },
        ],
        color: ["#0099FF"],
      };
      this.$echarts.init(this.$refs.rightEcharts1, "dark").setOption(option);
    },
    setRightEcharts2() {
      let xArr = ["Mon", "Tue", "Wed", "Thu", "Frifdffdsfds"];
      let yArr = [80, 70, 60, 50, 40];
      let arrMan = [];
      let dataFen = [];
      yArr.forEach((element) => {
        arrMan.push(yArr[0] + 10);
        dataFen.unshift(element);
      });
      var option = {
        backgroundColor: "",
        grid: {
          top: "10",
          left: "10",
          right: "30",
          bottom: "10",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          axisLine: { show: false },
          axisLabel: { show: true, color: "#ffffff", fontSize: 14 },
          axisTick: { show: false },
          splitLine: { show: false },
          data: xArr,
        },
        series: [
          {
            type: "bar",
            barWidth: "20%",
            barGap: "-100%",
            data: arrMan, //背影
            label: {
              show: true,
              position: "right",
              color: "#ffffff",
              // 标签内容格式化
              formatter: function(params) {
                for (let i = 0; i < dataFen.length; i++) {
                  if (params.dataIndex == i) {
                    return dataFen[params.dataIndex];
                  }
                }
              },
            },
            color: "rgba(180, 180, 180, 0.2)",
          },
          {
            type: "bar",
            stack: "Total",
            // showBackground: true,

            // label: {
            //   show: true,
            //   position: "right"
            // },
            barWidth: "20%",
            data: dataFen,
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 1, color: "#3B92FE" },
              { offset: 0.5, color: "#24BCF8" },
              { offset: 0, color: "#16E0E8" },
            ]),
          },
        ],
      };
      this.$echarts.init(this.$refs.rightEcharts2, "dark").setOption(option);
    },
    setRightEcharts3(xArr1, yArr1) {
      let xArr = xArr1;
      let yArr = yArr1;
      let option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false, //轴线刻度
          },
          boundaryGap: false,
          data: xArr,
          axisLabel: {
            color: "#ffffff",
            interval: 0,
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //x轴颜色
            },
          },
        },
        color: ["#277CD5"],
        yAxis: {
          type: "value",
          axisTick: {
            show: false, //轴线刻度
          },
          axisLabel: {
            color: "#ffffff",
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff", //Y轴颜色
            },
          },
          splitLine: {
            lineStyle: {
              color: "#505687",
            },
          },
        },
        series: [
          {
            // name: "Highest",
            data: yArr,
            type: "line",
            symbolSize: 1,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.1,
                  color: "#212a61",
                },
                {
                  offset: 1,
                  color: "#277CD5",
                },
              ]),
            },
            smooth: true,
            // markPoint: {
            //     data: [{ type: "max", name: "Max" }, { type: "min", name: "Min" }]
            // }
            // label: {  //显示值
            //     show: true,
            //     position: 'top'
            //   },
          },
        ],
      };
      this.$echarts.init(this.$refs.rightEcharts3, "dark").setOption(option);
    },
    setLeftEcharts() {
      let xArr = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let yArr = [120, 200, 150, 80, 70, 110];
      var option = {
        backgroundColor: "",
        tooltip: {},
        grid: {
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xArr,
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff", //x轴颜色
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "(辆)",
            nameTextStyle: {
              color: "#ffffff",
              align: "right",
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff", //y轴颜色
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            // name: "当月录制",
            type: "bar",
            barWidth: "30%",
            itemStyle: {
              //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
              barBorderRadius: [10, 10, 0, 0],
            },
            data: yArr,
          },
        ],
        color: ["#0099FF"],
      };
      this.$echarts.init(this.$refs.leftEcharts, "dark").setOption(option);
    },
    loadImage() {
      //加载完图片回调
      let imgRef = this.$refs.imgRef; //img的dom
      //有真实图片款高用注释部分，没有就用标签高度
      // this.imgNaturalData.width = imgRef.naturalWidth; //图片原始宽度
      // this.imgNaturalData.height = imgRef.naturalHeight; //图片原始高度
      // this.imgNaturalData.width = imgRef.width; //图片标签宽度
      // this.imgNaturalData.height = imgRef.height; //图片标签高度

      this.rect = this.$refs.imgRef.getBoundingClientRect();
      // this.imgScale = rect.height / 700; //现在图片和真实图片比例
      // alert(this.imgScale)
      // this.isImage = true;
      // this.handlePointListData(this.imgScale);
    },
    getFloorInfo(floorCode) {
      let item = this.floorShowList.find((item) => {
        return item.floorCode == floorCode;
      });
      return item;
    },
    //显示当前时间（年月日时分秒）
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      this.getWeek = year + "年" + month + "月" + date + "日";
      this.nowTime = hh + ":" + mm + ":" + ss + " " + getWeek;
    },
    nowTimes() {
      this.timeFormate(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear();
    },

    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.clear();
  },
};
</script>

<style lang="scss">
.screenSecurity2 {
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s linear;
    transform: translateX(0);
  }

  .fade-enter,
  .fade-leave-to {
    transform: translateX(-100%);
  }

  .moveR-enter-active,
  .moveR-leave-active {
    transition: all 0.5s linear;
    transform: translateX(0);
  }

  .moveR-enter,
  .moveR-leave,
  .moveR-leave-to {
    transform: translateX(100%);
  }

  width: 100%;
  color: #ffffff;
  height: 100%;
  text-align: center;
  background-color: rgb(52, 64, 92);
  transform: translateZ(0);

  .pageTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
    height: 80px;
  }

  .page {
    // border: 1px solid #000;
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    flex: 1;

    .pageImg {
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      text-align: left;
    }

    .leftShowButton {
      position: fixed;
      left: 0;
      top: 80px;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .leftDiv {
      width: 350px;
      position: fixed;
      left: 0;
      top: 80px;
      background-color: rgb(13, 17, 23, 0.4);
      text-align: center;
      height: calc(100% - 80px - 12px);
      .rightEcharts1 {
        height: 250px; // width:100%;
        /* border: 1px solid #b0b0b0; */
        // background-color: #212a61;
      }
      .left-block {
        width: 95%;
        margin: 0 auto;
        text-align: center;
        height: 400px; // color: rgba(255, 255, 255, 0.8);

        .list-block {
          height: 100%;
          overflow: hidden;

          .list {
            height: 100%;
            overflow: auto;
            /*IE*/
            -ms-overflow-style: none;
            /*火狐*/
            overflow: -moz-scrollbars-none;

            /*谷歌*/
            &::-webkit-scrollbar {
              //隐藏滚动条
              display: none;
            }

            .dongtai {
              width: 100%;
              position: relative;
              text-align: left;
              line-height: 25px;
              font-size: 18px;
              margin: 10px;

              p {
                font-size: 18px;
                font-family: SourceHanSansCN;
                font-weight: 400;
                color: #ffffff;
                line-height: 20px;
              }
            }
          }
        }

        //动画 平缓上偏移50%
        @keyframes row {
          0% {
          }

          100% {
            transform: translateY(-50%);
          }
        }

        .marquee {
          position: relative;

          .list {
            /* 调用动画 */
            height: initial;
            overflow: initial; // animation: row 15s linear infinite;  // 原先是写死的速度，由于数据不固定在html写了
          }

          .list:hover {
            // 鼠标悬停停止滚动
            animation-play-state: paused !important;
          }
        }
      }

      .leftEcharts {
        height: 290px;
        /* border: 1px solid #b0b0b0; */
        // background-color: #212a61;
      }

      .changeFloor {
        display: flex;
        z-index: 9999;
        font-size: 15px;
        width: 100%;
        justify-content: space-around;

        .floor {
          width: 53px;
          line-height: 30px;
          height: 30px; // border: 1px solid #e2e2e271;
          color: #65beff;
          border-radius: 10px;
          cursor: pointer;
        }

        .floorShow {
          width: 53px;
          line-height: 30px;
          height: 30px;
          border: 1px solid #65beff;
          color: #65beff;
          border-radius: 10px;
          cursor: pointer;
        }
      }

      .shoplist {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: 10px;
        margin-right: 10px;
        height: 30px;
        padding: 25px 20px;
        background-color: rgb(60, 60, 63, 0.9);
        margin-top: 8px;
        font-size: 15px;
      }
    }

    .rightShowButton {
      position: fixed;
      right: 0;
      top: 80px;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .rightDiv {
      width: 350px;
      background-color: rgb(13, 17, 23, 0.4);
      text-align: center;
      height: calc(100% - 80px - 12px);
      position: fixed;
      right: 0;
      top: 80px;
      text-align: left;

      .rightEcharts1 {
        height: 250px; // width:100%;
        /* border: 1px solid #b0b0b0; */
        // background-color: #212a61;
      }

      .rightEcharts2 {
        height: 250px; // width:100%;
        /* border: 1px solid #b0b0b0; */
        // background-color: #212a61;
      }

      .rightEcharts3 {
        height: 240px; // width:100%;
        /* border: 1px solid #b0b0b0; */
        // background-color: #212a61;
      }
    }

    .bottomDiv {
      width: calc(100% - 600px);
      top: 80px;
      height: auto;
      position: fixed;
      left: 300px;
      bottom: 12px; // background-color: rgba(111, 117, 134, 0.3);
      display: flex;
    }
  }
}

@keyframes twinkle {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.6;
  }
}
</style>
